import React from "react";
import CustomMultipleResourcePage from "../components/CustomMultipleResourcePage";
import { Container } from "@amzn/awsui-components-react";

const AccountingPolicyPage = ({selectedCPView, viewAccess, addOrEditAccess, resetHref}) => (
  <Container>
    <CustomMultipleResourcePage
        pageType="Accounting Policy"
        tabType="LIST"
        owner={selectedCPView}
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />
  </Container>

);

export default AccountingPolicyPage;
